import { createFileRoute } from '@tanstack/react-router';

import { TicketAddPage } from './-components/TicketAddPage';

export const Route = createFileRoute('/_stacktrace/development-tickets/add/')({
  component: TicketAddPage,
});
